import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import {ViewService} from "../../../services/common/view.service";
import {Partecipant} from "../../../classes/common/partecipant";
import {DataService} from "../../../services/common/data.service";


// type Layout =
//   "chip" |
//   "item";


@Component({
  selector: 'app-select-chip',
  templateUrl: './select-chip.component.html',
  styleUrls: ['./select-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectChipComponent implements OnInit {
  /*
    nested components
    'selector' list:
    --------------------------------
    app-car
  */


  // component args

  @Input() car: Partecipant;
  @Input() placeholder: string = "Seleziona veicolo";

  @Output() select = new EventEmitter<any>();
  @Input() disabled: boolean;


  // listener

  listener = {
    view: null,
  };


  constructor(
    private cd: ChangeDetectorRef,
    // private navCtrl: NavController,
    // navParams can only be used in modals and popovers!
    // private navParams: NavParams,
    // private tdweb: TdwebService,
    // private dataService: DataService,
    private popoverCtrl: PopoverController,
    // private alertCtrl: AlertController,
    // private modalCtrl: ModalController,
    // private api: ApiService,
    private view: ViewService,
    private data: DataService,
  ) {}


  ngOnInit() {
    // console.log("ngOnInit()");

    //  -------------------------
    //  listeners:

    this.listenerView();

    //  -------------------------

    // if (!this.status) {
    //   this.status = "off";
    // }
  }

  ngOnDestroy() {
    // console.log("ngOnDestroy()");

    //  -------------------------
    // disengage listeners:

    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }

    //  -------------------------
  }





  /*myFunc() {
    console.log("myfunc", typeof this.val == 'number')
    return typeof this.val == 'number';
  }*/





  // listener

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      // console.log("listener.view", obj);

      // this.zone.run(() => {

      this.view.pipeChanged++;
      this.cd.markForCheck();

      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);

      // });
    });
  }


  // popover

  async popoverSelectCar(event: any) {
    // Devo passargli tutti i participants con type === 2
    /* let cars: any[] = [];
    if(this.data.selOrganization && this.data.selOrganization.participants){
      for(let participant of this.data.selOrganization.participants){
        if(participant.type === 2){
          cars.push(participant);
        }
      }
    }

    const popover = await this.popoverCtrl.create({
      component: PopoverSelectCarComponent,
      componentProps: {
        cars: cars
      },
      cssClass: "popover_list",
      event: event,
    });
    popover.onDidDismiss().then((data: any) => {
      if(data && data.data){
        this.select.emit(data.data.car);
      }
    });
    await popover.present(); */
  }






}
